import { motion } from 'framer-motion';
import { FadeUp } from './MaskReveal';
import { ABOUT_CHAPTERS } from '../../lib/site-data';

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-ink-900 py-16 md:py-24">
      <div className="container-editorial">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left column – sticky intro */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <FadeUp>
                <span className="eyebrow">01 — About the firm</span>
              </FadeUp>
              <FadeUp delay={0.1}>
                <h2 className="display-heading mt-6 text-white text-4xl sm:text-5xl lg:text-6xl">
                  Our Beliefs.<br />
                  <span className="text-white/40">Our Foundations.</span>
                </h2>
              </FadeUp>
              <FadeUp delay={0.2}>
                <p className="mt-6 text-white/60 text-base leading-relaxed max-w-md">
                  Three chapters that describe how we think, who we serve, and what we set out to build.
                </p>
              </FadeUp>
              <FadeUp delay={0.3}>
                <div className="mt-10 flex items-center gap-4">
                  <span className="h-px w-16 bg-white/30" />
                  <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/50">Manifesto</span>
                </div>
              </FadeUp>
            </div>
          </div>

          {/* Right column – numbered chapters */}
          <div className="lg:col-span-7 flex flex-col divide-y divide-white/10">
            {ABOUT_CHAPTERS.map((c, i) => (
              <motion.article
                key={c.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-100px' }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 }}
                className="relative py-10 md:py-14 first:pt-0 group"
                data-testid={`about-chapter-${c.n}`}
              >
                <div className="flex items-start gap-6">
                  <span
                    aria-hidden
                    className="font-serif italic text-6xl md:text-8xl leading-none text-white/10 group-hover:text-signal-500/40 transition-colors duration-700 select-none"
                  >
                    {c.n}
                  </span>
                  <div className="flex-1 pt-2 md:pt-4">
                    <h3 className="display-heading text-2xl md:text-3xl text-white">
                      {c.title}
                    </h3>
                    <p className="mt-4 md:mt-5 text-white/70 text-base md:text-lg leading-relaxed max-w-2xl">
                      {c.body}
                    </p>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
